import { SpdrClientViewModel } from "../../ViewModel/SpdrClientViewModel";
import { FtlRouteViewModel } from "../../ViewModel/FtlRouteViewModel";
import { FtlRoutingViewModel } from "../../ViewModel/FtlRoutingViewModel";
import { ProjectStateType } from "../EditProjectContext";
import { createDockObjectForUndefindedPlant } from "./createDockObjectForUndefindedPlant";
import { createDockObjectForIndexMinus } from "./createDockObjectForIndexMinus";
import generateRoutingJson from "../GenerateRoutingJson";
import { PdsrClientViewModel } from "../../ViewModel/PdsrClientViewModel";
import { DraggableElement } from "../../ViewModel/DraggableElement";
import { setRoutingTable } from "../RightSide/FtlTab/FtlRouteHeader/AddGsdb/SetRoutingTable";
import { sortRoutingTable } from "./sortRoutingTable";
import { RoutingType } from "../../ViewModel/RoutingType";
import { RouteType } from "../../ViewModel/RouteType";

export const insertDragNDropCardToRoute = (
  draggedItem: SpdrClientViewModel | PdsrClientViewModel,
  ftlRouteFromProject: FtlRouteViewModel,
  databaseSupplier: FtlRoutingViewModel,
  databasePlant: FtlRoutingViewModel,
  projectState: ProjectStateType
) => {
  const draggableElements: Array<DraggableElement> = [];

  const findAllMatchingSuppliersOrPlantsOnFtlRoute = (
    ftlRoute: FtlRouteViewModel,
    supplierOrPlantFromDb: FtlRoutingViewModel,
    routingTypes: RoutingType[]
  ): Array<FtlRoutingViewModel> => {
    const allSupplierOrPlantsOnRoute = ftlRoute.RoutingTable?.filter(
      (route) =>
        route.Gsdb === supplierOrPlantFromDb.Gsdb &&
        route.PuDoType === supplierOrPlantFromDb.PuDoType &&
        routingTypes.map((routingType) => routingType === route.RoutingType)
    );
    return allSupplierOrPlantsOnRoute ?? [];
  };

  const possibleRoutingTypesForSupplier = [RoutingType.Supplier, RoutingType.EPC, RoutingType.ODC];
  const possibleRoutingTypesForPlant = [RoutingType.Plant, RoutingType.EPC, RoutingType.ODC];

  const suppliersOnRoute = findAllMatchingSuppliersOrPlantsOnFtlRoute(
    ftlRouteFromProject,
    databaseSupplier,
    possibleRoutingTypesForSupplier
  );

  const plantsOnRoute = findAllMatchingSuppliersOrPlantsOnFtlRoute(
    ftlRouteFromProject,
    databasePlant,
    possibleRoutingTypesForPlant
  );

  if (suppliersOnRoute.length === 0 && ftlRouteFromProject.RouteType !== RouteType.Trunk) {
    draggableElements?.push({
      RoutingType: RoutingType.Supplier,
      Gsdb: databaseSupplier.Gsdb,
      DockList: [],
      RoutingInfo: databaseSupplier,
    });
  }

  if (plantsOnRoute.length === 0 && databasePlant.IsEdcPlant) {
    draggableElements?.push({
      RoutingType: RoutingType.EDC,
      Gsdb: databasePlant.Gsdb,
      DockList: [],
      RoutingInfo: databasePlant,
    });
  } else if (
    plantsOnRoute.length === 0 &&
    databasePlant.RoutingType === RoutingType.Plant &&
    !databasePlant.IsEdcPlant
  ) {
    draggableElements?.push({
      RoutingType: RoutingType.Plant,
      Gsdb: databasePlant.Gsdb,
      DockList: createDockObjectForUndefindedPlant(databasePlant),
      RoutingInfo: databasePlant,
    });
  } else if (
    plantsOnRoute.length !== 0 &&
    !databasePlant.IsEdcPlant &&
    databasePlant.RoutingType === RoutingType.Plant
  ) {
    const existingDockWithSameDockCode = plantsOnRoute.find(
      (routing) => routing.DockCode === databasePlant.DockCode
    );

    if (existingDockWithSameDockCode === undefined) {
      draggableElements?.push({
        RoutingType: RoutingType.Plant,
        Gsdb: databasePlant.Gsdb,
        DockList: [createDockObjectForIndexMinus(databasePlant)],
        RoutingInfo: databasePlant,
      });
    }
  } else if (plantsOnRoute.length === 0 && databasePlant.RoutingType === RoutingType.ODC) {
    draggableElements?.push({
      RoutingType: RoutingType.ODC,
      Gsdb: databasePlant.Gsdb,
      DockList: [],
      RoutingInfo: databasePlant,
    });
  } else if (plantsOnRoute.length === 0) {
    draggableElements?.push({
      Gsdb: databasePlant.Gsdb,
      DockList: [],
      RoutingInfo: databasePlant,
    });
  }

  const routingTable = [
    ...(ftlRouteFromProject.RoutingTable || []),
    ...generateRoutingJson(ftlRouteFromProject, draggableElements),
  ];
  setRoutingTable(ftlRouteFromProject.RouteId, sortRoutingTable(routingTable), projectState);
};
